export default __webpack_public_path__ + "static/media/black-phone.68b0e9fd.svg";